module.exports = __webpack_public_path__ + "img/pf-processing.3acbbd1c.gif";